import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from 'i2g-ng-utils';

const SCHEMA = Object.freeze({
  PLATFORM: '',
});
const RECORD = generateSchema(SCHEMA);
const KEYS: any = generateKeys(SCHEMA);

export class LoginAttemptResult extends Record(RECORD) {
  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get platform(): string {
    return this.get(KEYS.PLATFORM);
  }
}
